// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"9aab695b","95":"9755336c","214":"a1c69859","246":"d3993390","419":"1b3a92fe","458":"95bbaa39","496":"ddaed5e5","765":"672d06f4","774":"e1b0ffca","858":"a70c023f"}[chunkId] + ".chunk.js";
};